import React, { useState } from 'react';
import './FiltersSidebar.css';

function FiltersSidebar({ filters, onFilterChange }) {
  const [expandedSections, setExpandedSections] = useState({
    city: true,
    propertyType: true,
    price: true,
    area: true,
    bedsBaths: true
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const cities = ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan', 'Peshawar', 'Quetta'];
  const propertyTypes = ['House', 'Flat', 'Upper Portion', 'Lower Portion', 'Farmhouse', 'Room', 'Penthouse'];
  const priceRanges = [
    { label: 'Any', value: '' },
    { label: '0 - 50 Lac', value: '0-5000000' },
    { label: '50 Lac - 1 Crore', value: '5000000-10000000' },
    { label: '1 - 2 Crore', value: '10000000-20000000' },
    { label: '2 - 5 Crore', value: '20000000-50000000' },
    { label: '5 Crore+', value: '50000000+' }
  ];
  const areaRanges = [
    { label: 'Any', value: '' },
    { label: '0 - 5 Marla', value: '0-125' },
    { label: '5 - 10 Marla', value: '125-250' },
    { label: '10 Marla - 1 Kanal', value: '250-500' },
    { label: '1 - 2 Kanal', value: '500-1000' },
    { label: '2 Kanal+', value: '1000+' }
  ];

  return (
    <div className="filters-sidebar">
      <div className="filters-header">
        <h3>Filters</h3>
        <button className="btn-reset" onClick={() => onFilterChange('reset')}>
          Reset All
        </button>
      </div>

      <div className="filter-section">
        <div
          className="filter-section-header"
          onClick={() => toggleSection('city')}
        >
          <h4>City</h4>
          <span className={`toggle-icon ${expandedSections.city ? 'expanded' : ''}`}>
            ▼
          </span>
        </div>
        {expandedSections.city && (
          <div className="filter-section-content">
            <div className="filter-search">
              <input
                type="text"
                placeholder="Search city..."
                className="filter-search-input"
              />
            </div>
            <div className="filter-options">
              {cities.map(city => (
                <label key={city} className="filter-checkbox">
                  <input
                    type="checkbox"
                    checked={filters.cities?.includes(city)}
                    onChange={(e) => onFilterChange('city', city, e.target.checked)}
                  />
                  <span>{city}</span>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="filter-section">
        <div
          className="filter-section-header"
          onClick={() => toggleSection('propertyType')}
        >
          <h4>Property Type</h4>
          <span className={`toggle-icon ${expandedSections.propertyType ? 'expanded' : ''}`}>
            ▼
          </span>
        </div>
        {expandedSections.propertyType && (
          <div className="filter-section-content">
            <div className="filter-options">
              {propertyTypes.map(type => (
                <label key={type} className="filter-checkbox">
                  <input
                    type="checkbox"
                    checked={filters.propertyTypes?.includes(type)}
                    onChange={(e) => onFilterChange('propertyType', type, e.target.checked)}
                  />
                  <span>{type}</span>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="filter-section">
        <div
          className="filter-section-header"
          onClick={() => toggleSection('price')}
        >
          <h4>Price Range</h4>
          <span className={`toggle-icon ${expandedSections.price ? 'expanded' : ''}`}>
            ▼
          </span>
        </div>
        {expandedSections.price && (
          <div className="filter-section-content">
            <div className="filter-range">
              <select
                value={filters.priceMin || ''}
                onChange={(e) => onFilterChange('priceMin', e.target.value)}
                className="filter-select"
              >
                <option value="">Min Price</option>
                {priceRanges.map(range => (
                  <option key={range.value} value={range.value}>
                    {range.label}
                  </option>
                ))}
              </select>
              <span className="range-separator">to</span>
              <select
                value={filters.priceMax || ''}
                onChange={(e) => onFilterChange('priceMax', e.target.value)}
                className="filter-select"
              >
                <option value="">Max Price</option>
                {priceRanges.map(range => (
                  <option key={range.value} value={range.value}>
                    {range.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </div>

      <div className="filter-section">
        <div
          className="filter-section-header"
          onClick={() => toggleSection('area')}
        >
          <h4>Area</h4>
          <span className={`toggle-icon ${expandedSections.area ? 'expanded' : ''}`}>
            ▼
          </span>
        </div>
        {expandedSections.area && (
          <div className="filter-section-content">
            <div className="filter-range">
              <select
                value={filters.areaMin || ''}
                onChange={(e) => onFilterChange('areaMin', e.target.value)}
                className="filter-select"
              >
                <option value="">Min Area</option>
                {areaRanges.map(range => (
                  <option key={range.value} value={range.value}>
                    {range.label}
                  </option>
                ))}
              </select>
              <span className="range-separator">to</span>
              <select
                value={filters.areaMax || ''}
                onChange={(e) => onFilterChange('areaMax', e.target.value)}
                className="filter-select"
              >
                <option value="">Max Area</option>
                {areaRanges.map(range => (
                  <option key={range.value} value={range.value}>
                    {range.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </div>

      <div className="filter-section">
        <div
          className="filter-section-header"
          onClick={() => toggleSection('bedsBaths')}
        >
          <h4>Beds & Baths</h4>
          <span className={`toggle-icon ${expandedSections.bedsBaths ? 'expanded' : ''}`}>
            ▼
          </span>
        </div>
        {expandedSections.bedsBaths && (
          <div className="filter-section-content">
            <div className="filter-beds-baths">
              <div className="bed-bath-group">
                <label>Bedrooms</label>
                <div className="number-selector">
                  {[1, 2, 3, 4, 5, '6+'].map(num => (
                    <button
                      key={num}
                      className={`number-btn ${filters.beds === num ? 'active' : ''}`}
                      onClick={() => onFilterChange('beds', num)}
                    >
                      {num}
                    </button>
                  ))}
                </div>
              </div>
              <div className="bed-bath-group">
                <label>Bathrooms</label>
                <div className="number-selector">
                  {[1, 2, 3, 4, 5, '6+'].map(num => (
                    <button
                      key={num}
                      className={`number-btn ${filters.baths === num ? 'active' : ''}`}
                      onClick={() => onFilterChange('baths', num)}
                    >
                      {num}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="filters-actions">
        <button className="btn-apply-filters">Apply Filters</button>
      </div>
    </div>
  );
}

export default FiltersSidebar;